import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_LOADING_PROCESSES, SET_PROCESSES, SET_LOADING_SELECTED_PROCESS, SET_SELECTED_PROCESS } from './mutations';
import api from '@/api';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

export const loadProcesses = buildActionObject('loadProcesses');
export const loadProcess = buildActionObject('loadProcess');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [loadProcesses.action]({ commit }) {
		commit(SET_LOADING_PROCESSES, true);
		try {
			commit(SET_PROCESSES, await api.getProcesses());
		} finally {
			commit(SET_LOADING_PROCESSES, false);
		}
	},

	async [loadProcess.action]({ commit }, processId) {
		commit(SET_LOADING_SELECTED_PROCESS, true);
		try {
			const resp = await api.getProcessReport(processId);
			commit(SET_SELECTED_PROCESS, resp);
		} finally {
			commit(SET_LOADING_SELECTED_PROCESS, false);
		}
	},
};

export default actions;
